module.exports = __webpack_public_path__ + "img/application.3525c75e.jpg";